import type { HashtagModel } from "src/features/Hashtags/models";

import { useInfiniteQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { SEARCH_MIN_CHARS } from "src/constants";

interface Options {
	enabled?: boolean;
}

const getNextPageParam = ({ next }: CMSPaginatedData<HashtagModel>) => {
	return next;
};

export const fetchHashtag = async (name?: string, nextPageUrl?: string) => {
	const url = nextPageUrl || `/hashtag/?search=${name}&page=1`;

	const { data } = await cmsClient.get<CMSPaginatedData<HashtagModel>>(url);

	return data;
};

const useHashtags = (name?: string, options: Options = { enabled: true }) => {
	const trimmed = (name ?? "").trim();
	const hasMinChars = trimmed.length >= SEARCH_MIN_CHARS;

	const query = useInfiniteQuery(
		["hashtags", trimmed],
		({ pageParam }) => fetchHashtag(trimmed, pageParam),
		{
			getNextPageParam,
			enabled: (options.enabled ?? true) && hasMinChars
		}
	);

	return query;
};

export default useHashtags;
